import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { CreateOrganizationPage } from 'src/apps/enterprise/app/pages/CreateOrganization';
import { z } from 'zod';
import { setupEnrollmentFormSchema } from '../link';

export const Route = createFileRoute(
  '/_auth/enterprise/enroll/create-organization'
)({
  component: () => <CreateOrganizationPage />,
  validateSearch: zodValidator(
    z.object({
      defaultValues: setupEnrollmentFormSchema.optional(),
    })
  ),
});
